import { geoProjects, utils } from "./modules/GeoProjects.js"; 
import SWLRIGeoProjectsList from "./components/GeoProjectsList.js";
import SWLRIGeoProjectsFilter from "./components/GeoProjectsFilter.js";

window.addEventListener('swlri-geo-projects-modules-loaded',()=>{
    window.customElements.define('swlri-geo-projects-filter', SWLRIGeoProjectsFilter);
    window.customElements.define('swlri-geo-projects', SWLRIGeoProjectsList);
})